module.exports = __webpack_public_path__ + "img/checked-green.f9d35c0f.svg";